import React, { Component, ErrorInfo, ReactNode } from "react";
import Translate from "../../Components/Translate";
import NotixLoggerService from "Services/logger";
import Alert, { ALERT_TYPES } from "@propellerads/alert";
// import * as Sentry from "@sentry/react";
// @ts-ignore
import Button, { BUTTON_TYPE } from "@propellerads/button";
import "./styles.scss";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error;
}

const CHUNK_ERROR = "ChunkLoadError";

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: {} as Error,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error: error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);

    let body = {
      message: `${error?.message} ErrorBoundary`,
      name: document.location.href,
      code: error?.name,
      stack: error?.stack,
    };

    NotixLoggerService.logError(body);
   // Sentry.captureException(error);

    if (error.name === CHUNK_ERROR) {
      this.reloadApp();
    }
  }

  private reloadApp = () => {
    window.location.reload();
  };

  public render() {
    const {
      hasError,
      error: { name, message },
    } = this.state;
    if (hasError) {
      return (
        <div className="ErrorBoundaryWrapper">
          <Alert type={ALERT_TYPES.DANGER}>
            <div className="ErrorBoundary">
              <h2>
                {name === CHUNK_ERROR ? (
                  <Translate tag="error-connection" />
                ) : (
                  <Translate tag="error-boundary-message" />
                )}
              </h2>
              <p>Name: {JSON.stringify(name)}</p>
              <p>Message: {JSON.stringify(message)}</p>
            </div>
          </Alert>
          <div className="ErrorBoundaryBtn">
            <Button elementId="" type={BUTTON_TYPE.PRIMARY} onClick={this.reloadApp}>
              <Translate tag="reload" />
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

// @ts-ignore
export default ErrorBoundary;
